var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 102,
    viewBox: "0 0 1440 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1101.54 1.04093C1294 -7.38875 1440 97.4651 1440 97.4651L1440 102.002H0V101.968C130.566 -19.6247 571.34 -3.38912 723.001 22.1106C855.504 32.2795 915.58 22.8232 974.764 13.5074C1011.61 7.70732 1048.11 1.96171 1101.54 1.04093Z",
    fill: "#24245A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.6a8ffb77ba9bcf425d35e17c4ceef1a7.svg";
export { ForwardRef as ReactComponent };